import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';

import ProviderSchedulingPage from './ProviderSchedulingPage';
import ProviderSchedulingPageQuery from './ProviderSchedulingPageQuery.graphql';

const ProviderSchedulingPageWithData = graphql(ProviderSchedulingPageQuery, {
  options({ match: { params } }) {
    return { variables: params };
  },
})(ProviderSchedulingPage);

ProviderSchedulingPageWithData.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default ProviderSchedulingPageWithData;
